export default __webpack_public_path__ + "static/media/ico-ticket.538576b2.svg";